import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { queryParamKeys } from 'modules/experiments/constants';
import { EXPERIMENTS_TABLE_COLUMNS, TableSortContextState } from 'modules/experiments/types';
import { FC } from 'react';
import {
  createSerializationOptionsForEnumValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { TableSortContext, initialTableSortContextState } from './TableSortContext';

export const TableSortContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [sortBy, setSortBy] = useSearchParamState({
    searchParamKey: queryParamKeys.sortBy,
    stateValueWhenSearchParamIsUnset: initialTableSortContextState.sortBy,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: EXPERIMENTS_TABLE_COLUMNS,
      stateValueWhenSearchParamIsInvalid: initialTableSortContextState.sortBy,
    }),
  });

  const [sortDirection, setSortDirection] = useSearchParamState({
    searchParamKey: queryParamKeys.sortDirection,
    stateValueWhenSearchParamIsUnset: initialTableSortContextState.sortDirection,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: SORT_DIRECTIONS,
      stateValueWhenSearchParamIsInvalid: initialTableSortContextState.sortDirection,
    }),
  });

  const context: TableSortContextState = {
    sortBy,
    setSortBy,
    sortDirection,
    setSortDirection,
  };

  return <TableSortContext.Provider value={context}>{children}</TableSortContext.Provider>;
};
